export default "__VITE_ASSET__nh9PG536__"